module.exports = __webpack_public_path__ + "img/jaru-logo-color.44e48ba8.svg";